"use client";

import { useContext } from "react";
import { PropertyContextType, PropertyContext } from "./PropertyContext";

export function useProperty(): PropertyContextType {
  return useContext(PropertyContext);
}
